import { useAuthStore } from '@/shared/store/authStore';
import { DEMO_WATERMARK_HTML } from '@/shared/utils/printBranding';

// What a demo company prints from the browser (a pay stub, a W-2, any page) carries
// the demo watermark on every page. Nothing shows on screen, and there is no setting.
export function DemoPrintWatermark() {
  const isDemo = useAuthStore((s) => s.company?.is_demo === true);
  if (!isDemo) return null;
  // Fixed text from this file's own constant, nothing a user typed.
  return <div className="hidden print:block" aria-hidden="true" dangerouslySetInnerHTML={{ __html: DEMO_WATERMARK_HTML }} />;
}
